import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { Accordion } from 'src/360ui/Accordion'
import clsx from 'clsx'

type SidebarProps = {
  newsletters: any
  setDataFilter: (data: any) => void
  setSearch: (data: any) => void
  yearFilter: any
  setYearFilter: (data: any) => void
  monthActive: any
  setMonthActive: (data: any) => void
  resetFilters: () => void
}
export const Sidebar = ({
  newsletters,
  setDataFilter,
  setSearch,
  setYearFilter,
  yearFilter,
  monthActive,
  setMonthActive,
  resetFilters,
}: SidebarProps) => {
  const filterByYear = year => {
    if (year === 'All') {
      resetFilters()
      return
    }

    setYearFilter(year)
    const filteredList = []
    newsletters.map(newsletter => {
      if (newsletter.year === year) {
        filteredList.push(newsletter)
      }
    })
    setDataFilter(filteredList)
  }

  const filterByYearAndMonth = (year, month) => {
    setMonthActive(month)
    setYearFilter(year)
    const filteredList = []
    newsletters.map(newsletter => {
      if (newsletter.year === year) {
        newsletter.months.map(months => {
          if (months.month === month) {
            months.newsletters.map(newsletterMonth => {
              if (!filteredList[newsletter.year])
                filteredList[newsletter.year] = {}
              if (!filteredList[newsletter.year][months.month])
                filteredList[newsletter.year][months.month] = []
              filteredList[newsletter.year][months.month].push(newsletterMonth)
            })
          }
        })
      }
    })
    const data = Object.entries(filteredList).map(([year, months]) => ({
      year,
      months: Object.entries(months).map(([month, newsletters]) => ({
        month,
        newsletters,
      })),
    }))
    setSearch('')
    setDataFilter(data)
  }

  return (
    <>
      <span
        className={clsx(styles.year, {
          [styles.allActive]: yearFilter === 'All',
        })}
        onClick={() => filterByYear('All')}
      >
        All
      </span>
      {newsletters?.map(newsletter => {
        return (
          <div key={newsletter.id} className={styles.element}>
            <Accordion
              header={newsletter.year}
              className={styles.year}
              classNameActive={
                newsletter.year === yearFilter ? styles.yearActive : ''
              }
              onClick={() => filterByYear(newsletter.year)}
            >
              <div className={styles.monthContainer}>
                {newsletter.months.map(month => {
                  return (
                    <span
                      key={`${newsletter.year}-${month.month}`}
                      onClick={() =>
                        filterByYearAndMonth(newsletter.year, month.month)
                      }
                      className={clsx(styles.month, {
                        [styles.allActive]:
                          monthActive.toLowerCase() ===
                            month.month.toLowerCase() &&
                          newsletter.year === yearFilter,
                      })}
                    >
                      {month.month}
                    </span>
                  )
                })}
              </div>
            </Accordion>
          </div>
        )
      })}
    </>
  )
}
